export default "__VITE_ASSET__8e309b90__"